import {
    handleRehydrateAction,
    handleRemoveAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import * as jobActions from '../job/job.actions';
import * as fromReportActions from './report.actions';
import { Report } from './report.model';

export interface State {
    ids: Array<string>;
    entities: { [id: string]: Report };
}

export const initialState: State = {
    ids: [],
    entities: {}
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(
    state = initialState,
    action: fromReportActions.Actions | jobActions.Actions
): State {
    switch (action.type) {
        case fromReportActions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case fromReportActions.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case fromReportActions.REMOVE: {
            return handleRemoveAction(state, action);

        }
        case jobActions.WIPE: {
            return {
                ...state,
                ids: [],
                entities: {}
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/report/report.reducer.ts